"use client";
/* eslint-disable */

import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import UvegCertificateNft from "../contractsData/UvegCertificateNft.json";

// === Config ===
const CONTRACT_ADDRESS = "0xaEbBB2C766b0927C870cfb7c024C0e9623e6d08C";
const ABI = UvegCertificateNft.abi || UvegCertificateNft;
const PREFERRED_GATEWAY = "https://ok-indigo-vole.myfilebase.com/ipfs"; // tu gateway

function ipfsToPreferred(uri) {
  if (!uri) return "";
  if (!uri.startsWith("ipfs://")) return uri; // ya es http(s)
  const m = uri.match(/^ipfs:\/\/([^/]+)(\/.*)?$/i);
  if (!m) return uri;
  const cid = m[1];
  const rest = m[2] || "";
  return `${PREFERRED_GATEWAY}/${cid}${rest}`;
}

function makeQrUrl(url) {
  if (!url) return "";
  return `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(
    url
  )}`;
}

function shortAddr(a) {
  if (!a) return "";
  return a.slice(0, 6) + "…" + a.slice(-4);
}

async function resolveImageFromTokenURI(tokenUri) {
  const resolved = ipfsToPreferred(tokenUri);
  // Si es metadata JSON, intentamos leer image
  if (/\.json(\?|$)/i.test(resolved)) {
    try {
      const res = await fetch(resolved, { cache: "no-store" });
      if (res.ok) {
        const meta = await res.json();
        if (meta?.image) return ipfsToPreferred(meta.image);
      }
    } catch {}
  }
  return resolved;
}

export default function AutoWalletNFTGallery() {
  const [owner, setOwner] = useState(""); // wallet detectada
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  // Listado de NFTs encontrados [{tokenId, imageUrl, qrUrl}]
  const [items, setItems] = useState([]);

  // Búsqueda manual
  const [showSearch, setShowSearch] = useState(false);
  const [manualAddr, setManualAddr] = useState("");
  const [manualTokenId, setManualTokenId] = useState(""); // opcional

  // Detectar cuenta conectada en MetaMask SIN pedir permisos y cargar NFTs
  useEffect(() => {
    let unsub = () => {};
    async function detect() {
      try {
        if (typeof window === "undefined" || !window.ethereum) return;
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const accs = await provider.send("eth_accounts", []); // no solicita permisos
        if (accs && accs[0]) {
          setOwner(accs[0]);
          fetchNfts(accs[0], null);
        }
        const onAccountsChanged = (accounts) => {
          const a = accounts && accounts[0] ? accounts[0] : "";
          setOwner(a);
          if (a) fetchNfts(a, null);
          else setItems([]);
        };
        window.ethereum.on?.("accountsChanged", onAccountsChanged);
        unsub = () => window.ethereum.removeListener?.("accountsChanged", onAccountsChanged);
      } catch {}
    }
    detect();
    return () => unsub();
  }, []);

  async function fetchNfts(ownerAddr, tokenIdOrNull) {
    setMsg("");
    setLoading(true);
    setItems([]);

    try {
      if (!ethers.utils.isAddress(ownerAddr)) {
        setMsg("Dirección inválida");
        return;
      }

      // RPC público de Polygon (solo lectura)
      const provider = new ethers.providers.JsonRpcProvider("https://polygon-rpc.com/");
      const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, provider);

      // Si se especifica tokenId, validamos pertenencia y mostramos solo ese
      if (tokenIdOrNull !== null && tokenIdOrNull !== undefined && `${tokenIdOrNull}`.trim() !== "") {
        const tid = ethers.BigNumber.from(tokenIdOrNull).toString();
        let actualOwner;
        try {
          actualOwner = await contract.ownerOf(tid);
        } catch (e) {
          setMsg(`El tokenId ${tid} no existe o no es consultable.`);
          return;
        }
        if (actualOwner.toLowerCase() !== ownerAddr.toLowerCase()) {
          setMsg(`El tokenId ${tid} no pertenece a ${ownerAddr}.`);
          return;
        }
        const tokenUri = await contract.tokenURI(tid);
        const img = await resolveImageFromTokenURI(tokenUri);
        setItems([{ tokenId: tid, imageUrl: img, qrUrl: makeQrUrl(img) }]);
        return;
      }

      // Caso general: traer TODOS los tokenIds de la wallet
      let ids = [];
      // Prefer tokensOfOwner si existe
      if (contract.functions?.tokensOfOwner) {
        try {
          ids = await contract.tokensOfOwner(ownerAddr);
        } catch {}
      }
      // Fallback: balanceOf + tokenOfOwnerByIndex
      if (!ids || ids.length === 0) {
        const bal = await contract.balanceOf(ownerAddr);
        const b = bal.toNumber ? bal.toNumber() : parseInt(bal);
        for (let i = 0; i < b; i++) {
          const idBn = await contract.tokenOfOwnerByIndex(ownerAddr, i);
          ids.push(idBn);
        }
      }

      if (!ids || ids.length === 0) {
        setMsg("No hay NFT minteado para esta wallet.");
        return;
      }

      // Obtener tokenURI e imagen para cada id
      const entries = await Promise.all(
        ids.map(async (bn) => {
          const tid = bn.toString ? bn.toString() : `${bn}`;
          try {
            const tokenUri = await contract.tokenURI(tid);
            const img = await resolveImageFromTokenURI(tokenUri);
            return { tokenId: tid, imageUrl: img, qrUrl: makeQrUrl(img) };
          } catch (e) {
            return { tokenId: tid, imageUrl: "", qrUrl: "", error: true };
          }
        })
      );

      setItems(entries);
    } catch (e) {
      console.error(e);
      setMsg(e?.reason || e?.message || "Error al consultar el contrato");
    } finally {
      setLoading(false);
    }
  }

  async function copyLink(url) {
    try {
      if (!url) return;
      await navigator.clipboard.writeText(url);
      setMsg("Enlace copiado al portapapeles");
      setTimeout(() => setMsg(""), 1500);
    } catch {
      setMsg("No se pudo copiar el enlace");
      setTimeout(() => setMsg(""), 1500);
    }
  }

  async function downloadQR(qrUrl) {
    try {
      if (!qrUrl) return;
      const res = await fetch(qrUrl, { cache: "no-store" });
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "qr_certificado.png";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    } catch {
      setMsg("No se pudo descargar el QR");
      setTimeout(() => setMsg(""), 1500);
    }
  }

  async function downloadPNG(imageUrl, tokenId) {
    try {
      if (!imageUrl) return;
      const res = await fetch(imageUrl, { cache: "no-store" });
      if (!res.ok) throw new Error("No se pudo descargar el PNG.");
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `certificado_${tokenId}.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    } catch (e) {
      setMsg(e?.message || "No se pudo descargar el PNG");
      setTimeout(() => setMsg(""), 1500);
    }
  }

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: 16 }}>
      <h2 style={{ marginBottom: 12 }}>MIS CERTIFICADOS</h2>

      {/* Estado de wallet */}
      {owner ? (
        <div style={{ marginBottom: 8, color: "#374151" }}>
          Wallet detectada: <span style={{ fontFamily: "monospace" }}>{shortAddr(owner)}</span>
        </div>
      ) : (
        <div style={{ marginBottom: 8, color: "#6b7280" }}>
          No hay wallet conectada en MetaMask. Puedes buscar otra wallet manualmente.
        </div>
      )}

      {/* Controles de búsqueda */}
      <div style={{ marginBottom: 12 }}>
        <button
          onClick={() => setShowSearch((v) => !v)}
          style={{
            padding: "10px 12px",
            border: "1px solid #d1d5db",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          {showSearch ? "Ocultar búsqueda" : "Buscar otra wallet / tokenId"}
        </button>
      </div>

      {showSearch && (
        <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
          <input
            value={manualAddr}
            onChange={(e) => setManualAddr(e.target.value)}
            placeholder="0x... dirección (requerida)"
            style={{ flex: 1, minWidth: 260, padding: "10px 12px", border: "1px solid #d1d5db" }}
          />
          <input
            value={manualTokenId}
            onChange={(e) => setManualTokenId(e.target.value)}
            placeholder="tokenId (opcional)"
            style={{ width: 180, padding: "10px 12px", border: "1px solid #d1d5db" }}
          />
          <button
            onClick={() =>
              fetchNfts((manualAddr || "").trim(), (manualTokenId || "").trim() || null)
            }
            disabled={loading}
            style={{ padding: "10px 12px" }}
          >
            {loading ? "Buscando..." : "Buscar"}
          </button>
          {owner && (
            <button
              onClick={() => fetchNfts(owner, null)}
              disabled={loading}
              style={{ padding: "10px 12px", border: "1px solid #d1d5db", background: "#fff" }}
            >
              Refrescar mis NFTs
            </button>
          )}
        </div>
      )}

      {msg && <div style={{ color: "#b91c1c", marginBottom: 12 }}>{msg}</div>}

      {/* Grid de NFTs */}
      {loading ? (
        <div>Buscando NFTs…</div>
      ) : items.length === 0 ? (
        <div style={{ color: "#6b7280" }}>Sin resultados.</div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
            gap: 16,
          }}
        >
          {items.map((it) => (
            <div
              key={it.tokenId}
              style={{ border: "1px solid #e5e7eb", background: "#fff", padding: 12 }}
            >
              <div style={{ marginBottom: 8, color: "#374151", fontWeight: 600 }}>
                Token #{it.tokenId}
              </div>

              <div
                style={{
                  border: "1px solid #e5e7eb",
                  background: "#f8fafc",
                  padding: 8,
                  textAlign: "center",
                  minHeight: 120,
                }}
              >
                {it.imageUrl ? (
                  <img
                    src={it.imageUrl}
                    alt={`token-${it.tokenId}`}
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                ) : (
                  <div style={{ color: "#6b7280" }}>No se pudo resolver la imagen.</div>
                )}
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "140px 1fr",
                  gap: 10,
                  marginTop: 12,
                }}
              >
                <div style={{ color: "#374151", fontSize: 14 }}>Contrato</div>
                <div style={{ fontFamily: "monospace", fontSize: 12 }}>{CONTRACT_ADDRESS}</div>
              </div>

              {/* QR */}
              {it.qrUrl && (
                <div
                  style={{
                    border: "1px solid #e5e7eb",
                    padding: 12,
                    background: "#fff",
                    textAlign: "center",
                    marginTop: 12,
                  }}
                >
                  <div style={{ marginBottom: 8, color: "#374151" }}>
                    Escanéa el QR para abrir la imagen
                  </div>
                  <img src={it.qrUrl} alt="QR imagen" width={240} height={240} />
                </div>
              )}

              {/* Acciones */}
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  justifyContent: "flex-end",
                  marginTop: 12,
                  flexWrap: "wrap",
                }}
              >
                <a
                  href={it.imageUrl || "#"}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    padding: "8px 12px",
                    border: "1px solid #2563eb",
                    background: "#2563eb",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  Abrir enlace
                </a>
                <button
                  onClick={() => copyLink(it.imageUrl)}
                  style={{ padding: "8px 12px", border: "1px solid #d1d5db", background: "#fff", cursor: "pointer" }}
                >
                  Copiar enlace
                </button>
                <button
                  onClick={() => downloadPNG(it.imageUrl, it.tokenId)}
                  style={{ padding: "8px 12px", border: "1px solid #d1d5db", background: "#fff", cursor: "pointer" }}
                >
                  Descargar PNG
                </button>
                <button
                  onClick={() => downloadQR(it.qrUrl)}
                  style={{ padding: "8px 12px", border: "1px solid #0ea5e9", background: "#0ea5e9", color: "#fff", cursor: "pointer" }}
                >
                  Descargar QR
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
